export default __webpack_public_path__ + "static/giveimageflip-f5dbda1dcc8c76703b8d500ab02aed1d.png";